<template>
  <div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">独立页面</li>
    </ol>
    <div class="am-scrollable-horizontal">
      <table class="am-table am-table-hover am-text-nowrap">
        <thead>
        <tr>
          <th>ID</th>
          <th>页面标题 [页面缩略名]</th>
          <th>创建时间</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="page in pageList">
          <tr>
            <td>{{page.id}}</td>
            <td>
              <router-link :key="page.id" :to="{path:`/edit/page/${page.slug}`}">{{page.title}} [{{page.slug}}]</router-link>
              <span v-if="page.status===2" class="am-badge am-badge-warning am-radius">隐藏</span>
              <span v-if="page.status===3" class="am-badge am-badge-success am-radius">密码保护</span>
              <span v-if="page.status===4" class="am-badge am-badge-danger am-radius">私密</span>
            </td>
            <td>{{page.createTime}}</td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">独立页面</li>
    </ol>
  </div>
</template>

<script>
import { adminPageGetList } from '@/request'
export default {
  name: 'EditPages',
  data () {
    return {
      pageList: []
    }
  },
  mounted () {
    adminPageGetList().then(res => {
      this.pageList = res
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditPages.vue